import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline, secondaryFill }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M107.989 41.87C107.989 41.87 80.3593 27.42 78.9593 25.66C77.5593 23.9 76.6193 1 76.6193 1H54.6093C54.6093 1 53.6693 23.9 52.2693 25.66C50.8693 27.42 23.2393 41.87 23.2393 41.87C23.2393 41.87 35.4893 56.92 65.6193 56.92C95.7493 56.92 107.989 41.87 107.989 41.87Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M121.71 49.39C118.63 45.76 84.07 28.58 84.07 28.58L78.94 19L65.61 26.54L52.28 19L47.15 28.58C47.15 28.58 12.59 45.75 9.51 49.39C6.44 53.02 2 74.16 2 74.16H129.23C129.23 74.16 124.79 53.02 121.71 49.39Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M84.0692 28.7601L73.1292 40.3201L65.5592 27.1101L58.0992 40.3201L47.1592 28.7601"
        fill={fill}
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path d="M63.8994 28.63V73.97" stroke={outline} strokeMiterlimit="10" />
      <path d="M67.2998 28.52V73.86" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M79.7095 22L65.6095 27.88L51.5195 22L51.8295 39.18L65.6095 31.34L79.3995 39.18L79.7095 22Z"
        fill={secondaryFill}
      />
      <path d="M38.1395 75.21L33.5995 34L28.7695 36.45L33.1895 75.21H38.1395Z" fill="#513019" />
      <path d="M92.1797 75.21L96.7197 34L101.56 36.45L97.1397 75.21H92.1797Z" fill="#513019" />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="65.6143"
          y1="56.9222"
          x2="65.6143"
          y2="1"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
